export enum SellDialogState {
  Creation = 'creation',
  Withdrawal = 'withdrawal',
  Confirmation = 'confirmation',
  Success = 'success',
}
